const numberFormatter = new Intl.NumberFormat("fr-FR", {
  maximumFractionDigits: 2,
});

const integerFormatter = new Intl.NumberFormat("fr-FR", {
  maximumFractionDigits: 0,
});

const dateFormatter = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

const toFiniteNumber = (value: number | string | null | undefined) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const formatSubscriptionNumber = (
  value: number | string | null | undefined,
) => integerFormatter.format(toFiniteNumber(value) ?? 0);

export const formatSubscriptionAmount = (
  value: number | string | null | undefined,
  currency: string | null | undefined = "XOF",
) => {
  const parsedValue = toFiniteNumber(value);

  if (parsedValue === null) return "—";

  return `${numberFormatter.format(parsedValue)} ${currency || "XOF"}`;
};

export const formatSubscriptionDate = (
  value: string | Date | null | undefined,
) => {
  if (!value) return "—";

  const dateOnlyMatch =
    typeof value === "string" ? value.match(/^(\d{4})-(\d{2})-(\d{2})/) : null;
  const parsedDate = dateOnlyMatch
    ? new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3]),
        12,
      )
    : new Date(value);

  if (Number.isNaN(parsedDate.getTime())) return "—";

  return dateFormatter.format(parsedDate);
};

export const formatBillingCycle = (value: string | null | undefined) => {
  const labels: Record<string, string> = {
    monthly: "Mensuel",
    quarterly: "Trimestriel",
    annual: "Annuel",
    yearly: "Annuel",
  };

  return value ? labels[value] || value : "Non défini";
};
